import { GlBadge, GlPopover } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
const SHOW_DELAY = 500;
const DISMISS_TIMEOUT = 6000;
export default {
    name: 'FileTreeBrowserPopover',
    components: {
        GlBadge,
        GlPopover
    },
    props: {
        targetElement: {
            type: HTMLElement,
            required: true
        }
    },
    emits: [
        'dismiss'
    ],
    data () {
        return {
            show: false
        };
    },
    mounted () {
        this.initializePopover();
    },
    beforeDestroy () {
        if (this.popoverShowTimeout) {
            clearTimeout(this.popoverShowTimeout);
        }
        if (this.popoverDismissTimeout) {
            clearTimeout(this.popoverDismissTimeout);
        }
        this.removeTargetListeners();
    },
    methods: {
        initializePopover () {
            this.popoverShowTimeout = setTimeout(()=>{
                this.show = true;
            }, SHOW_DELAY);
            this.attachTargetListeners();
            this.popoverDismissTimeout = setTimeout(()=>{
                this.show = false;
            }, DISMISS_TIMEOUT);
        },
        attachTargetListeners () {
            if (this.targetElement) {
                this.removeTargetListeners();
                this.onTargetHoverOrFocus = ()=>{
                    this.show = false;
                };
                this.targetElement.addEventListener('mouseenter', this.onTargetHoverOrFocus);
                this.targetElement.addEventListener('focus', this.onTargetHoverOrFocus);
            }
        },
        removeTargetListeners () {
            if (this.targetElement && this.onTargetHoverOrFocus) {
                this.targetElement.removeEventListener('mouseenter', this.onTargetHoverOrFocus);
                this.targetElement.removeEventListener('focus', this.onTargetHoverOrFocus);
            }
        }
    }
};
